export const RedirectLoader = (windowName, urls, ssoUrls) => {
    const wn = windowName
    try {
        // const existingWindow = window.open('', wn);
        // if (existingWindow[0] !== undefined) {
        //     existingWindow.location.href = urls;
        // } else {
        window.open(ssoUrls, wn).focus();
        // }
    } catch (error) {
        window.location.href = ssoUrls;
    }
}